import { array_uniq } from 'webui/utils/array';
export async function loadDataFromServerForZontGraphs(api, requests) {
    try {
        const json = await api.load_data(requests.map(({ data_types, mintime, maxtime, options, device_id }) => ({
            data_types: array_uniq(data_types),
            mintime,
            maxtime,
            options,
            device_id,
        })));
        return json;
    }
    catch (error) {
        return Promise.reject(error);
    }
}
